import fetch from "../utils/fetch";

// 修改密码
export function resetPasswordByOldPassword(data) {
  return fetch({
    url: "/api/auth/reset_pw_by_password",
    method: "put",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}

// 获取验证码
export function fetchCode(data) {
  return fetch({
    url: "/api/verifications/fetch_sms_code",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}

// 通过密码和验证码修改手机号
export function resetPasswordByPasswordAndCode(data) {
  return fetch({
    url: "api/auth/reset_mobile_by_password",
    method: "put",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}

// 获取邮箱验证码
export function fetchEmailCode(data) {
  return fetch({
    url: "/api/verifications/fetch_email_code",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}

// 通过密码和邮箱验证码修改邮箱地址
export function resetPasswordByPasswordAndEmailCode(data) {
  return fetch({
    url: "api/auth/reset_email",
    method: "put",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}
